export const SIDE_MODAL_WIDTH = Object.freeze({
  xs: ['460px', '460px'],
  sm: ['632px', '632px'],
  md: ['768px', '768px'],
  lg: ['992px', '992px'],
  xl: ['90vw', '1344px'],
});
